import { EVehicleAssetType } from '@/context/borrower';
import { DEFAULT_PARTNER } from '@/partners/defaultPartner';
import { ELenderSorting, LODGE_LENDERS } from '@/partners/matchingEngineEnums';
import {
    DEFAULT_TERMS_AND_CONDITIONS_LINK,
    REACT_APP_BANK_STATEMENTS_REFERRER_CODE_3M,
    REACT_APP_BANK_STATEMENTS_REFERRER_CODE_6M,
    REACT_APP_BANK_STATEMENTS_REFERRER_CODE_12M,
} from '@/utils/constants';

import { EDisplays, EJourneys, EModals, IDisplaySlice } from '../types';

import { initialGlassGuideLookUpVehicle } from './initialGlassGuideLookUpVehicle';
export const getStoredValue = <T>(key: string, defaultValue: T): string | T => {
    try {
        const storedValue = localStorage.getItem(key);
        return storedValue !== null ? storedValue : defaultValue;
    } catch (error) {
        // In case of any errors with localStorage, return default value
        return defaultValue;
    }
};

// Get stored timestamp and convert to Date object if exists
export const getStoredTimestamp = (): Date | null => {
    try {
        const timestamp = localStorage.getItem('smsLastRequestTimestamp');
        return timestamp ? new Date(parseInt(timestamp)) : null;
    } catch (error) {
        return null;
    }
};
export const initialDisplaySlice: IDisplaySlice = {
    stockIntegration: undefined,
    display: EDisplays.BASIC,
    previousDisplay: undefined,
    modal: EModals.WELCOME,
    showWelcomeScreen: false,
    isLoaded: false,
    isWhiteLabel: false,
    logo: 'https://driveiq-assets.s3.ap-southeast-2.amazonaws.com//vroom/assets/dog_1732682462826_lodge.png',
    fullLogoUrl: false,
    initialLoad: false,
    showOcrDisplay: false,
    isLoading: false,
    agreedToTermsAndConditions: {},
    glassGuideLookUpVehicleResults: initialGlassGuideLookUpVehicle,
    termsAndConditionsLink: DEFAULT_TERMS_AND_CONDITIONS_LINK,
    hideSellerScreen: false,
    hideVehicleScreen: false,
    showTotalAmountPayable: false,
    partnerName: null,
    partnerNumber: null,
    partnerEmail: null,
    waterfallLenders: [{ lenders: LODGE_LENDERS, showLenderDetails: true }],
    makeSpecificLenders: [
        {
            make: '',
            tierLenders: [
                {
                    lenders: [],
                    showLenderDetails: false,
                },
            ],
        },
    ],
    isAssetKnownViaParams: false,
    partner: DEFAULT_PARTNER,
    askTermsAndConditions: false,
    lenderSorting: ELenderSorting.CHEAPEST,
    sendLeadEmail: false,
    novatedCost: {
        medicare: 0,
        taxPayable: 0,
        monthlySaving: 0,
        annualSaving: 0,
        termSaving: 0,
        novated: {
            financeOnly: 0,
            fullyMaintained: 0,
            annualSaving: 0,
            fuel: 0,
            registration: 0,
            maintenanceRepairs: 0,
            tyres: 0,
            insurance: 0,
            adminFee: 0,
            totalLeaseRentalExGST: 0,
            preTaxDeduction: 0,
            postTaxDeduction: 0,
        },
        consumer: {
            financeOnly: 0,
            fullyMaintained: 0,
            annualSaving: 0,
            fuel: 0,
            registration: 0,
            maintenanceRepairs: 0,
            tyres: 0,
            insurance: 0,
            adminFee: 0,
            totalLeaseRentalExGST: 0,
            preTaxDeduction: 0,
            postTaxDeduction: 0,
        },
    },
    availableVehicleAssetTypes: [
        {
            label: 'Car, Van or Ute',
            type: EVehicleAssetType.COMMERCIAL_VEHICLES_LESS_THEN_4_5_TONNES,
        },
    ],
    requireGlassGuide: true,
    illionCodes: {
        threeMonths: REACT_APP_BANK_STATEMENTS_REFERRER_CODE_3M,
        sixMonths: REACT_APP_BANK_STATEMENTS_REFERRER_CODE_6M,
        twelveMonths: REACT_APP_BANK_STATEMENTS_REFERRER_CODE_12M,
    },
    isAssetAndLiabilitiesSubmitSkipped: false,
    initialJourney: EJourneys.FINANCE,
    showScanwarePopup: false,
    vehicleManualEntry: false,
    isPriceKnownViaExternal: false,
    isDemoMode: false,
    smsRequestAttempts:
        parseInt(getStoredValue('smsRequestAttempts', '0')) || 0,
    smsLastRequestTimestamp: getStoredTimestamp(),
};
